/**
 * 객체의 키를 한국어로 변환하는 함수
 * did -> DID, name -> 이름으로 변환
 */
export interface InputData {
  did?: string;
  name?: string;
  phone_number?: string;
  date_of_birth?: string;
  gender?: string;
  nationality?: string;
  mobile_number?: string;
  ci?: string;
  di?: string;
  expiration_date?: string;
}

export interface OutputData {
  DID?: string;
  이름?: string;
  전화번호?: string;
  생년월일?: string;
  성인여부?: string;
  청소년여부?: string;
  성별?: string;
  국적?: string;
  휴대폰번호?: string;
  CI?: string;
  DI?: string;
  만료일자?: string;
}

/**
 * 입력 객체의 키를 변환하는 함수
 * 값이 없는 경우 해당 키는 결과 객체에 포함되지 않음
 * @param input - 변환할 객체
 * @returns 변환된 객체 (값이 있는 필드만 포함)
 */
export function transformKeys(
  input: InputData,
  type: "signup" | "adult" | "minor"
): OutputData {
  const result: OutputData = {};

  if (input.did !== undefined && input.did !== null && input.did !== "") {
    result.DID = input.did;
  }
  if (input.name !== undefined && input.name !== null && input.name !== "") {
    result.이름 = input.name;
  }
  if (
    input.phone_number !== undefined &&
    input.phone_number !== null &&
    input.phone_number !== ""
  ) {
    result.전화번호 = input.phone_number;
  }
  if (
    input.date_of_birth !== undefined &&
    input.date_of_birth !== null &&
    input.date_of_birth !== ""
  ) {
    if (type === "signup") {
      result.생년월일 = input.date_of_birth;
    } else if (type === "adult") {
      result.성인여부 = input.date_of_birth;
    } else {
      result.청소년여부 = input.date_of_birth;
    }
  }
  if (
    input.gender !== undefined &&
    input.gender !== null &&
    input.gender !== ""
  ) {
    result.성별 = input.gender;
  }
  if (
    input.nationality !== undefined &&
    input.nationality !== null &&
    input.nationality !== ""
  ) {
    result.국적 = input.nationality;
  }
  if (
    input.mobile_number !== undefined &&
    input.mobile_number !== null &&
    input.mobile_number !== ""
  ) {
    result.휴대폰번호 = input.mobile_number;
  }
  if (input.ci !== undefined && input.ci !== null && input.ci !== "") {
    result.CI = input.ci;
  }
  if (input.di !== undefined && input.di !== null && input.di !== "") {
    result.DI = input.di;
  }
  if (
    input.expiration_date !== undefined &&
    input.expiration_date !== null &&
    input.expiration_date !== ""
  ) {
    result.만료일자 = input.expiration_date;
  }

  return result;
}

/**
 * 사용 예시:
 * const input = { did: "ASDAD", name: "askdja" };
 * const output = transformKeys(input);
 * console.log(output); // { DID: "ASDAD", 이름: "askdja" }
 */
